// extracted by mini-css-extract-plugin
export default {"errorPageWrapper":"NotFoundContent_errorPageWrapper__CSLCI","errorPageContentWrap":"NotFoundContent_errorPageContentWrap__OG9QV"};